import React, { Component } from "react";
import { Popconfirm } from "antd";
import {InfoCircleOutlined} from "@ant-design/icons"
export default class CustomPopconfirm extends Component {
  render() {
    return (
      <div>
        <Popconfirm
          title={this.props.title}
          okText={this.props.okText}
          cancelText={this.props.cancelText}
          onConfirm={() => this.props.onConfirm()}
          okType = "primary"
          icon={<InfoCircleOutlined style={{ color: 'red' }} />}
        >
          {this.props.content}
        </Popconfirm>
      </div>
    );
  }
}
